export default "__VITE_ASSET__1805105b__"